import React from 'react';

const ConnectWalletMessage = () => {
  return (
    <div className='bg-gray-900 rounded-md p-3'>
      <p className='text-xl text-gray-200'>Please connect your Discord account to continue.</p>
    </div>
  );
};

export default ConnectWalletMessage;
